import { HealthPackageItem, TSelectedHealthPackageItem } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

type TPostPackageConfigPayload = Omit<
  TSelectedHealthPackageItem,
  "total_price" | "package_expiry_from_start"
> &
  Partial<
    Pick<
      TSelectedHealthPackageItem,
      "total_price" | "package_expiry_from_start"
    >
  >;

export default async function postPackageConfig({
  data,
}: {
  data: TPostPackageConfigPayload;
}): Promise<TrystGenericResponse<HealthPackageItem>> {
  const TRYST_HOST = GET_TRYST_HOST();
  const headers = new Headers();

  headers.append("accept", "application/json");
  headers.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify({ payload: data }),
  };

  try {
    const response = await fetch(
      `${TRYST_HOST}/package/config`,
      requestOptions
    );

    return await response.json();
  } catch (error) {
    return {
      success: false,
      error: "Failed to post package config.",
    };
  }
}
